import React from 'react';
import {TableRow, TableCell, Button} from "@mui/material";
import ViewActiveIcon from "../../assets/icons/view-active.png";
import {useNavigate} from "react-router-dom";
import moment from "moment";
import Tooltip, {tooltipClasses} from "@mui/material/Tooltip";
import {styled} from "@mui/system";

const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{popper: className}} />

    ))(({theme}) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: "#fff",
            color: "rgba(51, 51, 207, 0.808)",
            boxShadow: "0px 5px 5px -3px rgb(0 0 0 / 10%), 0px 8px 10px 1px rgb(0 0 0 / 4%), 0px 3px 14px 2px rgba(0,0,0,0.12)",
            fontSize: 13,
            padding: theme.spacing(2),
            borderRadius: theme.shape.borderRadius, 
        },
  
        "& .MuiTooltip-arrow": {
            color: "#fff", 

            "&:before": {
                //
            }
        }
    })
);

const AnomalyRowData = ({anomaly, index}) => {

    const navigate = useNavigate();

    return (
        <TableRow key={index}>  
            <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                {anomaly?.ovi}
            </TableCell>

            <TableCell align="left" sx={{color: "#58565F"}}>
                {anomaly?.product?.product_name}
            </TableCell>

            <TableCell component="th" scope="row" sx={{color: "#58565F", textAlign: "center", cursor: (anomaly?.verificationLogs?.location) ? "pointer" : "default",
                maxWidth: "350px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
            }}>
                <LightTooltip arrow placement="top" title={anomaly?.verificationLogs?.location}>
                    <span>{anomaly?.verificationLogs?.location ? anomaly?.verificationLogs?.location : "N / A"}</span>
                </LightTooltip>
            </TableCell>

            <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                {moment(anomaly?.timestamp).format("MMMM DD, YYYY h:mm:ss A")}
            </TableCell>

            <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                {anomaly?.fraud_type}
            </TableCell>

            <TableCell component="th" scope="row" sx={{color: "#58565F",
                maxWidth: "210px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", 
            }}>
                {(anomaly?.remarks) ? anomaly?.remarks : "N / A"}
            </TableCell>

            <TableCell align="left">
                <Button variant="outlined" startIcon={<img alt="" src={ViewActiveIcon} style={{height: 16}} />}
                    sx={{textTransform: "none", borderColor: "#7A78F7", color: "rgba(51, 51, 207, 0.808)"}}
                    onClick={(e) => navigate("/anomaly-detection/details?anomalyId=" + anomaly?.anomaly_id)}
                >
                    View
                </Button>
            </TableCell>
        </TableRow>
    )
}

export default AnomalyRowData